module.exports = __webpack_public_path__ + "static/media/aphnit_simple_wide.19a80fa2.svg";